/* SLIDE 18 */

import React from "react";
import SearchBar from "shared/components/SearchBar";
import SubHeader from "shared/components/SubHeader";
import searchIcon from "assets/icons/searchIcon.svg";
import emptyIcon from "assets/icons/emptyIcon.svg";
import EmptySite from "../../../shared/components/EmptySite";

const ParkingPaymentEmpty = () => {
    const parkingData = [

    ];

    return (
        <div className="htContainer">
            <SubHeader >
                <div className={`sub-header-text w-full justify-between`} >
                    <div className="nl-row">
                        <span className="htColorGray2">주차장명 : </span>
                        <span className="htBold">새마을시장(01-002)</span>
                    </div>
                    <div className="nl-row">
                        <img src={searchIcon} alt="searchIcon" style={{height: "16px", width: "16px"}} />
                        <span className="htColorGray ml-5" style={{fontSize: "14px"}}>주차장 검색</span>
                    </div>
                </div>
            </SubHeader>

            <SearchBar />
            <div className="htContent">


                <table className="parking-table mn-parking-table">
                    <thead>
                        <tr>
                            <th>차량번호</th>
                            <th>입차일시</th>
                            <th>출차일시</th>
                            <th>미납금액</th>
                        </tr>
                    </thead>
                    <tbody>
                        {parkingData.map((item) => (
                            <tr key={item.id}>
                                <td>{item.vehicleNum}</td>
                                <td>
                                    <div className="flex flex-col">
                                        <span>{item.entryTime.split(" ")[0]}</span>
                                        <span>{item.entryTime.split(" ")[1]}</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="flex flex-col">
                                        <span>{item.entryTime.split(" ")[0]}</span>
                                        <span>{item.entryTime.split(" ")[1]}</span>
                                    </div>
                                </td>
                                <td>
                                    3,000
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {parkingData.length === 0 && (
                    <EmptySite></EmptySite>
                )}
            </div>


        </div>
    );
};

export default ParkingPaymentEmpty;
